module.exports = __webpack_public_path__ + "dist/assets/img/T.ad0c8750.svg";